import React, { useState } from "react";

const ChooseService = ({
  groupedServices,
  selectedServices,
  onToggleService,
  handleQuantityChange,
}) => {
  const [openGroups, setOpenGroups] = useState([]);

  const toggleGroup = (id) => {
    if (openGroups.includes(id)) {
      setOpenGroups(openGroups.filter((g) => g !== id));
    } else {
      setOpenGroups([...openGroups, id]);
    }
  };

  if (groupedServices.length === 0) {
    return <h1>Loading..</h1>;
  }

  return (
    <>
      <h3 className="mb-4">Choose Your Services</h3>

      {groupedServices.map((group) => {
        const isOpen = openGroups.includes(group.id);

        return (
          <div key={group.id} className="mb-4">
            {/* Accordion Title */}
            <h5
              className={`ps-2 service-group-title mb-3 ${isOpen ? "open" : ""}`}
              style={{ cursor: "pointer" }}
              onClick={() => toggleGroup(group.id)}
            >
              {group.name}
            </h5>

            {/* Accordion Content */}
            {isOpen && (
              <ul className="list-group">
                {group.services.map((service) => {
                  const isSelected = selectedServices.some(
                    (s) => s.id === service.id,
                  );

                  return (
                    <React.Fragment key={service.id}>
                      <li
                        onClick={() => onToggleService(service)}
                        className={`list-group-item mt-1 d-flex justify-content-between align-items-center service-item ${
                          isSelected ? "active text-white" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                      >
                        <div>
                          <strong>{service.name}</strong>
                          <div
                            className={`small ${
                              isSelected ? "text-light" : "text-muted"
                            }`}
                          >
                            {service.price} €
                          </div>
                        </div>

                        <span className="badge bg-secondary">
                          {isSelected ? "Selected" : "Choose"}
                        </span>
                      </li>

                      {isSelected && service.isRepeatable && (
                        <li className="list-group-item d-flex justify-content-between align-items-center service-item active">
                          <div className="input-group service-quantity">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() =>
                                handleQuantityChange(
                                  service.id,
                                  Math.max(
                                    1,
                                    (selectedServices.find(
                                      (s) => s.id === service.id,
                                    )?.quantity || 1) - 1,
                                  ),
                                )
                              }
                            >
                              −
                            </button>

                            <input
                              type="text"
                              className="form-control text-center"
                              value={
                                selectedServices.find(
                                  (s) => s.id === service.id,
                                )?.quantity || "1"
                              }
                              onChange={(e) => {
                                let value = e.target.value.replace(/\D/g, "");
                                if (value === "") value = "1";

                                let number = parseInt(value, 10);
                                if (number < 1) number = 1;
                                if (number > 5) number = 5;

                                handleQuantityChange(service.id, number);
                              }}
                            />

                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() =>
                                handleQuantityChange(
                                  service.id,
                                  Math.min(
                                    5,
                                    (selectedServices.find(
                                      (s) => s.id === service.id,
                                    )?.quantity || 1) + 1,
                                  ),
                                )
                              }
                            >
                              +
                            </button>
                          </div>
                        </li>
                      )}
                    </React.Fragment>
                  );
                })}
              </ul>
            )}
          </div>
        );
      })}
    </>
  );
};

export default ChooseService;
